<template>
  <div class="empty-status-wrap__container">
    <div class="empty-status-wrap__img-container">
      <img src="@/assets/image/service-not-avaliable.png">
      <p>服務已下架</p>
    </div>
    <v-btn
      class="empty-status-wrap__btn"
      depressed
      color="primary"
      @click="goHomePage"
    >
      回到首頁
    </v-btn>
  </div>
</template>

<script>
export default {
  methods: {
    goHomePage () {
      this.$nuxt.$router.push('/')
    }
  }
}
</script>
<style lang="scss">
@include empty-status-page;
</style>
